import axios from '../config/axios';
const API_BASE_URL = 'https://api.lottoquizvzla.com/v1';
const CHECKOUT = '/sports-draw';

export const sportDrawActive = async (online = false,isEmailValid = false, tvId = undefined) => {
  try {
    const { data } = await axios.get(`${CHECKOUT}/status`,{
      params: {
        online,
        isEmailValid,
        tvId
      }
    });
    return data;
  } catch (error) {
    if (error.response) {
      return error.response;
    }
    return error;
  }
};

export const fetchPayment = (accessToken) => {
  return fetch(`${API_BASE_URL}/auth-api/payment`, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
      },
  })
      .then((response) => response.json())
      .catch((error) => console.error('Error:', error));
}
